<template>
  <div class="nomor-surat-input">
    <label class="section-label">Nomor Surat</label>
    <p v-if="showDescription" class="section-description">
      Apabila nomor surat sudah digunakan oleh surat yang dibuat di luar sistem, gunakan tombol
      tambah (+) untuk menaikkan nomor surat
    </p>
    <div class="input-wrapper" :class="{ 'has-error': error }">
      <a-input
        :value="modelValue"
        class="nomor-input"
        :status="error ? 'error' : ''"
        :disabled="disabled"
        @update:value="(val) => $emit('update:modelValue', val)"
      />
      <a-button v-if="!disabled" type="text" class="btn-action" @click="handleIncrement">
        <PlusOutlined />
      </a-button>
      <a-button
        v-if="!disabled"
        type="text"
        class="btn-action"
        @click="handleDecrement"
        :disabled="!canDecrement"
      >
        <MinusOutlined />
      </a-button>
    </div>
    <span v-if="error" class="error-message">{{ error }}</span>
    <span v-if="checking" class="checking-message">Memeriksa nomor surat...</span>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { PlusOutlined, MinusOutlined } from '@ant-design/icons-vue'

export default defineComponent({
  name: 'NomorSuratInput',
  components: {
    PlusOutlined,
    MinusOutlined,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    canDecrement: {
      type: Boolean,
      default: false,
    },
    showDescription: {
      type: Boolean,
      default: true,
    },
    error: {
      type: String,
      default: '',
    },
    checking: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'increment', 'decrement'],
  setup(props, { emit }) {
    const handleIncrement = () => {
      emit('increment')
    }

    const handleDecrement = () => {
      emit('decrement')
    }

    return {
      handleIncrement,
      handleDecrement,
    }
  },
})
</script>

<style lang="scss" scoped>
.nomor-surat-input {
  margin-bottom: 24px;

  .section-label {
    display: block;
    font-weight: 500;
    color: #262626;
    margin-bottom: 8px;
    font-size: 14px;
  }

  .section-description {
    font-size: 12px;
    color: #8c8c8c;
    margin-bottom: 8px;
  }

  .input-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;

    &.has-error {
      .nomor-input {
        border-color: #ff4d4f;
      }
    }

    .nomor-input {
      flex: 1;
      background: #f5f5f5;
      color: #262626;
    }

    .btn-action {
      width: 32px;
      height: 32px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      &:disabled {
        color: #d9d9d9;
        cursor: not-allowed;
      }
    }
  }

  .error-message {
    display: block;
    color: #ff4d4f;
    font-size: 14px;
    margin-top: 4px;
    line-height: 1.5;
  }

  .checking-message {
    display: block;
    color: #1890ff;
    font-size: 12px;
    margin-top: 4px;
    line-height: 1.5;
  }
}
</style>
